import { footerLinks, siteName } from '@/mocks/home';

function jumpTo(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide">{siteName}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100/80">
              一个围绕{siteName}使用需求整理的信息指南页，帮你快速搞懂入口、APP、会员与免费观看，
              以及遇到打不开或需要换地址时的解决思路。
            </p>
          </div>

          <nav>
            <h3 className="font-heading text-sm font-semibold text-primary-50">站内导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 md:grid-cols-1">
              {footerLinks.slice(0, 4).map((l) => (
                <li key={l.anchor}>
                  <button
                    type="button"
                    onClick={() => jumpTo(l.anchor)}
                    className="text-sm text-primary-100/80 transition-colors hover:text-primary-50 cursor-pointer whitespace-nowrap"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <nav>
            <h3 className="font-heading text-sm font-semibold text-primary-50">问题排查</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 md:grid-cols-1">
              {footerLinks.slice(4).map((l) => (
                <li key={l.anchor}>
                  <button
                    type="button"
                    onClick={() => jumpTo(l.anchor)}
                    className="text-sm text-primary-100/80 transition-colors hover:text-primary-50 cursor-pointer whitespace-nowrap"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-primary-100/20 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs leading-relaxed text-primary-100/70">
            © {new Date().getFullYear()} {siteName}使用指南 · 本页为信息整理与操作指引，内容以实际使用页面为准。
          </p>
          <button
            type="button"
            onClick={() => jumpTo('top')}
            className="inline-flex items-center gap-1.5 rounded-md border border-primary-100/30 px-3 py-1.5 text-xs text-primary-50 transition-colors hover:bg-primary-800 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}